import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'

export function EmptyQueue() {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={{ width: '100%' }}>
      <Trans>No patient in queue</Trans>
    </Typography>
  )
}
